/**
 * API de token/puntos usando Axios.
 * Usa endpoints de PointApi (puntos).
 */
import { axiosInstance } from "features/shared/api";
import type { PointDto, PointCaducityDto } from "common/models";

export const tokenApi = {
    findByAddress: (tokenAddress: string) =>
        axiosInstance.get<PointDto>(`/api/points/${tokenAddress}`).then((r) => r.data),

    getPointCaducity: (organizationAddress: string) =>
        axiosInstance
            .get<PointCaducityDto>("/api/points/point-caducity", { params: { organizationAddress } })
            .then((r) => r.data),

    getSentPointsReceipt: (transactionHash: string) =>
        axiosInstance
            .get<string>(`/api/points/sent-points-receipt/${transactionHash}`, {
                responseType: "text",
            })
            .then((r) => r.data),
};
